import { Box } from "arkh";

export function WorkspaceSignalItemRowContainer(props: {
  priority: React.ReactNode;
  description: React.ReactNode;
  published: React.ReactNode;

  more: React.ReactNode;
  topic?: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <WorkspaceSignalPrioColumnContainer>
        {props.priority}
      </WorkspaceSignalPrioColumnContainer>
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <Box style={{ width: props.topic ? "50%" : "70%" }} spaceRight="medium">
          {props.description}
        </Box>
        {props.topic ? (
          <Box style={{ width: "20%", minWidth: 100 }} spaceRight="small">
            {props.topic}
          </Box>
        ) : null}
        <Box
          style={{
            width: "30%",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
          spaceRight="small"
        >
          {props.published}
        </Box>
      </Box>

      <Box
        style={{ width: 20, alignItems: "center", justifyContent: "center" }}
      >
        {props.more}
      </Box>
    </Box>
  );
}

export function WorkspaceSignalPrioColumnContainer(props: {
  children: React.ReactNode;
}) {
  return <Box style={{ width: 50 }}>{props.children}</Box>;
}
